import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["train-by-recovery"]!;

export function Body() {
  return (
    <>
      <p>
        Some days you wake up ready to train. Other days your legs are heavy and you slept
        badly. A fixed training plan doesn't know the difference. A Finnish study from 2022
        looked at what happens when recreational runners adjust their training to how
        recovered they are.
      </p>

      <h2>What the researchers did</h2>
      <p>
        The final analysis included thirty recreational runners after a three-week preparation
        period and twelve weeks of training. One group followed a fixed plan. The
        other group had its plan adjusted twice a week, on Mondays and Thursdays, for the next
        three to four days.
      </p>
      <p>
        The adjustment was based on three things: heart rate variability measured with a watch
        during the night, how tired and sore the runners felt, and how their heart rate
        compared with their running speed. If the signals looked good, training went up a
        little. If they looked poor, it went down.
      </p>

      <h2>What they found</h2>
      <p>
        Both groups got faster. The group that trained by recovery improved its 10K time by 6.2
        percent on average. The group on the fixed plan improved by 2.9 percent.
      </p>

      <h2>How sure can we be?</h2>
      <p>
        It was a small study, and the runners adjusted on several signals at once, so we can't
        say how much came from heart rate variability alone. A review that pooled eight studies
        of training guided by heart rate variability found benefits for some physiological
        measures, but no clear overall gain in race performance. The idea is promising, but not
        proven.
      </p>

      <h2>What you can do now</h2>
      <p>
        You don't need special equipment to start. Notice how you feel before a hard session:
        heavy legs, poor sleep, unusual soreness. If several of those come together, it is
        reasonable to make the session easier or move it a day.
      </p>
      <p>
        If you measure heart rate variability with your watch, look at the trend over several
        days rather than a single night, and only compare measurements taken the same way at
        the same time.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training combines your feedback with suitable measurements when they are available. HRV
        needs enough comparable nights to establish your own normal range. Missing readings
        stay unknown; a single watch score cannot override symptoms or unusual tiredness.
        Recovery information can support an easier session or rest. It does not by itself
        prove which workout will produce the greatest gain.
      </p>

      <h2>Sources</h2>
      <ul>
        <li>
          Nuuttila et al. (2022), Individualized endurance training based on recovery and
          training status in recreational runners.{" "}
          <a href="https://doi.org/10.1249/MSS.0000000000002968">Medicine & Science in Sports & Exercise</a>.
        </li>
        <li>
          Düking et al. (2021), Monitoring and adapting endurance training on the basis of heart
          rate variability monitored by wearable technologies.{" "}
          <a href="https://doi.org/10.1016/j.jsams.2021.04.012">Journal of Science and Medicine in Sport</a>.
        </li>
      </ul>
    </>
  );
}
